module.exports = __webpack_public_path__ + "static/img/img(61).ffe46d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/training/img(61).png
// module id = iSCs
// module chunks = 1